import React, {
  useState,
  useEffect,
  Fragment,
  useCallback,
  useContext,
} from "react";
import {
  useNavigate,
  useLocation,
  NavLink,
  useSearchParams,
} from "react-router-dom";

import "../Scss/ContactStyles.scss?v=1.1.3";
import {
  Grid,
  Button,
  Skeleton,
  ButtonGroup,
  Alert,
  Divider,
  Fade,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import { Star, Edit, PersonAdd } from "@mui/icons-material";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import ObservationsCards from "../../Components/ObservationsCards";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";
import api from "../../api/axios";
import {
  arrayToStatus,
  notesHistoricLogic,
  nuevoArrayDeNotas,
} from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";
import DuplicatedAlertList from "../../Components/helpers/ContactPlusClient/DuplicatedAlertList";
import ContactClientNotesComparisonDialog from "../../Components/ContactClientNotesComparisonDialog";
import { Dashboard, Save, TableChart } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { PermissionContext } from "../../Components/Context/Context";
import Unauthorized from "../../Components/Common/Design/Unauthorized";

const statusStyles = {
  "Pte. Llamada": {
    border: "1px solid #f8ac59",
    backgroundColor: "#f8ac59",
    color: "white",
  },
  Llamado: {
    border: "1px solid #23c6c8",
    backgroundColor: "#23c6c8",
    color: "white",
  },
  Cliente: {
    border: "1px solid #1ab394",
    backgroundColor: "#1ab394",
    color: "white",
  },
  Cancelado: {
    border: "1px solid #ed5565",
    backgroundColor: "#ed5565",
    color: "white",
  },
};

const statusName = (estado) => {
  switch (Number(estado)) {
    case 0:
      return "Pte. Llamada";
    case 1:
      return "Llamado";
    case 2:
      return "Cliente";
    case 3:
      return "Cancelado";
    default:
      return "Sin asignar";
  }
};

const renderStatus = (estado) => {
  const name = statusName(estado);
  const styles = statusStyles[name] || {};
  return (
    <span
      style={{
        padding: "3px 15px",
        fontSize: "14px",
        fontWeight: "bold",
        ...styles,
      }}>
      {name}
    </span>
  );
};

const Ver = () => {
  const { goEdit, goTable } = useLocationHelpers();
  const Swal = require("sweetalert2");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const contactId = searchParams.get("id");
  const [sameNifForbidden, setSameNifForbidden] = useState(false);

  // State
  const [contactData, setContactData] = useState(null);
  const [multipleContacts, setMultipleContacts] = useState([]);
  const [multipleClients, setMultipleClients] = useState([]);
  const [flag, setFlag] = useState(false);
  const [flagNotFound, setFlagNotFound] = useState(false);
  const [flagVip, setFlagVip] = useState(false);
  const [flagClientFounded, setFlagClientFounded] = useState(false);
  const [flagSameDocument, setFlagSameDocument] = useState(false);
  const [flagContactNoExistence, setFlagContactNoExistence] = useState(false);
  const [statuses, setStatuses] = useState(arrayToStatus);

  const [differentNotes, setDifferentNotes] = useState([]);
  const [flagToReload, setFlagToReload] = useState(false);

  const { can } = useContext(PermissionContext);
  const [unauthorized, setUnauthorized] = useState(false);

  // GET DATA
  const getContact = async () => {
    setFlag(false);

    try {
      const url = `${process.env.REACT_APP_API_URL}/contacts/show`;
      const { data } = await api.post(url, { id: contactId });

      const {
        contact,
        observations_contact = [],
        multiple_contacts = [],
        multiple_clients = [],
      } = data;

      console.log(data);

      const sameNifContacts = contact?.nif
        ? multiple_contacts.filter(
            (c) => c.nif === contact.nif && c.nif != "" && c.contact != "",
          )
        : [];

      setSameNifForbidden(sameNifContacts);

      multiple_contacts?.length === 0 && !contact
        ? setFlagContactNoExistence(true)
        : setFlagContactNoExistence(false);

      if (!contact) {
        setFlagNotFound(true);
        return;
      }

      console.log(multiple_contacts);
      console.log(multiple_clients);

      setMultipleContacts(
        Array.isArray(multiple_contacts) && multiple_contacts.length > 0
          ? multiple_contacts
          : [],
      );
      setMultipleClients(
        Array.isArray(multiple_clients) && multiple_clients.length > 1
          ? multiple_clients
          : [],
      );

      console.log(multiple_clients);

      // Safe destructuring with defaults
      const {
        name = "",
        surname = "",
        email = "",
        address = "",
        company_id = "",
        province = "",
        postalcode = "",
        nif = "",
        phone = "",
        notas = "",
        condiciones = "",
        marketing = 0,
        status = "",
        lawyers_relation = {},
        assigned_relation = {},
        company_relation = {},
        offices_relation = {},
        asociations_relation = {},
        document_types_relation = {},
        types_relation = {},
        date_in = "",
      } = contact;

      console.log(observations_contact);
      const processedConditions = condiciones?.replaceAll("<br />", "\n");

      const transformedNotes = nuevoArrayDeNotas(observations_contact) || {
        conClave: [],
        sinClave: [],
      };

      const resultadoFinal = [
        ...(Array.isArray(transformedNotes.conClave)
          ? transformedNotes.conClave
          : []),
        ...(Array.isArray(transformedNotes.sinClave)
          ? transformedNotes.sinClave
          : []),
      ];

      setContactData({
        id: contactId,
        name,
        surname,
        assignTo: assigned_relation,
        defaultLawyer: lawyers_relation,
        email,
        contactCompany: company_relation,
        address,
        contactOffice: offices_relation,
        province,
        company_id,
        postalcode,
        document: nif,
        document_type: document_types_relation,
        phone,
        contactAsociation: asociations_relation,
        contactCaseType: types_relation,
        marketingToSend: marketing,
        status,
        observations: "",
        cards: resultadoFinal.length > 0 ? resultadoFinal : [],
        contactConditions: processedConditions,
      });

      setFlagVip(processedConditions?.toLowerCase().includes("vip") || false);

      ////////////////////////////// HANDLING //////////////////////////////
      var cleaner = false;

      cleaner = await notesHistoricLogic(
        contact,
        multiple_clients?.length == 1 ? multiple_clients[0] : null,
        setDifferentNotes,
      );

      if (
        multiple_clients.length === 1 &&
        multiple_clients[0]?.id &&
        company_relation?.id == multiple_clients[0]?.company_id
      ) {
        const client = multiple_clients[0];

        const flagContact = client?.nif == contact?.nif;

        console.log(flagContact);
        setFlagClientFounded(client);
        setFlagSameDocument(flagContact);
      }
      if (cleaner) setFlagToReload((prev) => !prev);
      ////////////////////////////// HANDLING //////////////////////////////
    } catch (error) {
      setFlagContactNoExistence(true);
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setFlag(true);
    }
  };

  // Redirigir a edición como cliente
  const handleFormContactsToClient = async () => {
    Swal.fire({
      title: "¿Desea convertir cliente?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        const params = new URLSearchParams(location.search);
        params.delete("flag");
        params.append("flag", "true");
        navigate(`/contactos/editar?${params.toString()}`);
      }
    });
  };

  // Datos de contacto principales
  const contactInfo = [
    {
      label: "Nombre",
      value: `${contactData?.name || "--"} ${contactData?.surname || " "}`,
    },
    {
      label: "Documento",
      value: `${contactData?.document_type?.name || "--"} / ${
        contactData?.document || "--"
      }`,
    },
    { label: "Dirección", value: `${contactData?.address || "--"}` },
    { label: "Provincia", value: `${contactData?.province || "--"}` },
    { label: "Código postal", value: `${contactData?.postalcode || "--"}` },
    { label: "Teléfono", value: `${contactData?.phone || "--"}` },
    { label: "Email", value: `${contactData?.email || "--"}` },
    { label: "Estado actual", value: renderStatus(contactData?.status) },
  ];

  // Datos de empresa
  const companyInfo = [
    {
      label: "Asignado a",
      value: `${contactData?.assignTo?.name || "--"} ${
        contactData?.assignTo?.surname || ""
      }`,
    },
    {
      label: contactData?.contactCompany?.id === 11 ? "Procurador" : "Abogado",
      value: `${contactData?.defaultLawyer?.name || "--"} ${
        contactData?.defaultLawyer?.surname || "--"
      }`,
    },
    {
      label: "Tipo de caso",
      value: contactData?.contactCaseType?.case_type || "--",
    },
    {
      label: "Empresa",
      value: contactData?.contactCompany?.company_name || "--",
    },
    {
      label: "Asociación",
      value: contactData?.contactAsociation?.asoc_name || "--",
    },
  ];

  const dividerSx = { width: "100%", margin: "10px 0" };
  const labelSx = { height: "30px" };
  const valueSx = { color: "#676a6c" };

  const hasPermission = can("contacts", "view");
  const noContactData = !contactData || !contactData.name;

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getContact();
  }, [contactId, flagToReload, can]);

  const uniqueRelation =
    flagSameDocument &&
    flagClientFounded?.id &&
    flagClientFounded?.company_id == contactData?.company_id;

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Contactos" subTitle="Ver" />

      {noContactData && flagContactNoExistence && (
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <Alert severity="error">El contacto no existe...</Alert>
          </Grid>
        </Grid>
      )}

      {!hasPermission && <Unauthorized />}

      {flag && hasPermission && contactData && (
        <LoadingPage isLoading={!flag} heightProp={"600px"} />
      )}

      {flag && hasPermission && contactData && (
        <Fade timeout={600} in>
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            alignItems="stretch"
            className="fontSize">
            {/* ================= ALERTA CLIENTE ASOCIADO ================= */}
            {uniqueRelation && (
              <Grid item xs={12} sx={{ mb: 1 }}>
                <Alert severity="info" className="alertStyles">
                  <span>
                    Se ha encontrado un cliente asociado a este contacto,
                    agregue sus observaciones aquí:
                  </span>

                  <Button
                    component={NavLink}
                    to={`/clientes/ver?id=${flagClientFounded?.id}`}
                    size="small"
                    color="info"
                    variant="outlined"
                    sx={{ ml: 2 }}>
                    Ver Cliente
                  </Button>
                </Alert>
              </Grid>
            )}

            <Grid
              container
              spacing={1}
              item
              xs={12}
              sx={{ padding: "8px" }}
              width={"100%"}>
              {multipleContacts?.length > 0 && (
                <DuplicatedAlertList
                  items={multipleContacts}
                  entityName="contacto"
                  createNoteButton={true}
                />
              )}
              {multipleClients.length > 1 && (
                <DuplicatedAlertList
                  items={multipleClients}
                  entityName="cliente"
                />
              )}
            </Grid>

            {/* ================= DATOS CONTACTO / EMPRESA ================= */}
            <Grid item lg={5} md={6} xs={12} sx={{ p: 1, height: "100%" }}>
              <Paper
                elevation={4}
                sx={{
                  p: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "6px",
                  boxShadow: "0px 0px 25px -6px #1800b926",
                }}>
                {/* ----- CONTACTO ----- */}
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                  DATOS CONTACTO
                </Typography>

                <Divider sx={{ mb: 2 }} />

                {contactInfo.map((info, index) => (
                  <Grid container spacing={1} key={index} sx={{ mb: 1 }}>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body2" fontWeight={600}>
                        {info.label}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      <Typography
                        variant="body2"
                        sx={{ wordBreak: "break-word" }}>
                        {info.value || "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}

                {/* ----- EMPRESA ----- */}
                <Divider sx={{ my: 2 }} />

                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                  DATOS EMPRESA
                </Typography>

                <Divider sx={{ mb: 2 }} />

                {companyInfo.map((info, index) => (
                  <Grid container spacing={1} key={index} sx={{ mb: 1 }}>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body2" fontWeight={600}>
                        {info.label}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      <Typography
                        variant="body2"
                        sx={{ wordBreak: "break-word" }}>
                        {info.value || "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Paper>
            </Grid>

            {/* ================= NOTAS ================= */}
            <Grid item lg={7} md={6} xs={12} sx={{ p: 1, height: "100%" }}>
              <Paper
                elevation={1}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "6px",
                  boxShadow: "0px 0px 25px -6px #1800b926",
                }}>
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, mb: 1 }}>
                    NOTAS
                  </Typography>

                  <Divider sx={{ mb: 2 }} />

                  {/* ----- CONDICIONES ----- */}
                  {contactData.contactConditions === "" ? (
                    <Alert severity="warning">Sin condiciones asignadas.</Alert>
                  ) : (
                    <>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, mb: 1 }}>
                        CONDICIONES
                      </Typography>

                      <Alert
                        severity="info"
                        sx={{
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        {flagVip && <Star sx={{ mr: 1 }} />}
                        {contactData.contactConditions?.toUpperCase()}
                      </Alert>
                    </>
                  )}

                  {/* ----- OBSERVACIONES ----- */}
                  <>
                    <Divider sx={{ my: 2 }} />

                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, mb: 1 }}>
                      OBSERVACIONES
                    </Typography>

                    <Box sx={{ maxHeight: 320, overflowY: "auto", pr: 1 }}>
                      {/* Diferencias */}
                      {differentNotes?.length > 0 && (
                        <Alert severity="warning" sx={{ mb: 2 }}>
                          <Typography variant="body2">
                            El cliente y el contacto tienen notas diferentes.
                            Unifique las notas para habilitar la creación.
                          </Typography>

                          <ContactClientNotesComparisonDialog
                            notas={differentNotes}
                            client={flagClientFounded || []}
                            contact={contactData || []}
                            setFlagToReload={setFlagToReload}
                            flagToReload={flagToReload}
                          />
                        </Alert>
                      )}

                      {/* Cards */}
                      {Array.isArray(contactData?.cards) &&
                        contactData.cards.map((card, index) => {
                          const statusName =
                            statuses.find((opt) => opt.id === card.status)
                              ?.nombre || "Desconocido";

                          return (
                            <ObservationsCards
                              key={card?.id || index}
                              observationId={card?.id}
                              created_by_name={
                                card?.created_by_relation?.name || "-"
                              }
                              created_by_surname={
                                card?.created_by_relation?.surname || "-"
                              }
                              created_by_object={card?.created_by_relation}
                              date={card?.created_at || "Indefinido"}
                              title={card?.title || "Sin título"}
                              content={card?.notas || ""}
                              caseType={card?.types_relation?.case_type}
                              status_name={statusName}
                            />
                          );
                        })}
                    </Box>
                  </>
                </Box>
              </Paper>
            </Grid>

            {/* ================= BOTONES ================= */}
            <Grid container p={1}>
              <Grid
                item
                xs={12}
                sx={{
                  borderRadius: 2,
                  boxShadow: "0px 0px 25px -6px #1800b926",
                  background: "#fff",
                  padding: 2,
                }}>
                {console.log(contactData?.status)}

                <ButtonGroup fullWidth size="small">
                  {can("clients", "add") && (
                    <Button
                      onClick={handleFormContactsToClient}
                      variant="contained"
                      color="info"
                      startIcon={<PersonAdd />}
                      disabled={
                        sameNifForbidden?.length > 1 ||
                        uniqueRelation ||
                        contactData?.status === 2
                      }>
                      Hacer Cliente
                    </Button>
                  )}

                  {can("contacts", "edit") && (
                    <Button
                      component={Link}
                      to={`/contactos/editar?id=${contactId}`}
                      variant="outlined"
                      color="success"
                      startIcon={<Edit />}>
                      Editar
                    </Button>
                  )}

                  {can("contacts", "view") && (
                    <Button
                      component={Link}
                      to="/contactos"
                      variant="outlined"
                      color="error"
                      startIcon={<TableChart />}>
                      Tabla contactos
                    </Button>
                  )}
                </ButtonGroup>
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      )}
    </div>
  );
};

export default Ver;
